import { ScadenzeClient, ExpirationsSettingsClient } from "../generated";
import { ExpirationsActions } from "./ExpirationsActions.1";

export const service = new ScadenzeClient();
export const settingsService = new ExpirationsSettingsClient();

export default new ExpirationsActions();